/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import drillingPages from '@/app/drilling/pages.js'

const drillPages = new drillingPages();

export default [
  {
    url: "/",
    name: "Home",
    i18n: 'Home',
    slug: "home",
    icon: "HomeIcon"
  },
  {
    header: 'Apps',
    icon: 'PackageIcon',
    i18n: 'Apps',
    items: [
      {
        url: "/bsg",
        name: "BSG",
        i18n: 'BSG.Title',
        slug: "BSG",
        icon: "DollarSignIcon",
        requireRoles: [
          'CashflowReaders',
          'CashflowWriter',
          'KPUReaders',
          'Admin'
        ],
        submenu: [
          {
            url: "/bsg/cashflow",
            name: "CashFlow",
            i18n: 'CashFlow.Title',
            slug: "bsg-cashflow",
            icon: "DollarSignIcon",
            requireRoles: [
              'CashflowReaders',
              'CashflowWriter',
              'Admin'
            ]
          },
          {
            url: "/bsg/kpu",
            name: "Kpus",
            i18n: 'KPU.MainTitle',
            slug: "bsg-kpus",
            icon: "DollarSignIcon",
            requireRoles: [
              'KPUReaders',
              'KPUCollaborators',
              'Admin'
            ]
          },
          {
            url: "/bsg/decarbonization",
            name: "Decarbonization",
            i18n: 'Decarbonization.Title',
            slug: "bsg-decarbonization",
            icon: "DollarSignIcon",
            requireRoles: [
              'DecarbonizationReaders',
              'DecarbonizationCollaborators',
              'Admin'
            ]
          }
        ]
      },
      {
        url: "/geo",
        name: "Geo",
        i18n: 'Geo.Title',
        slug: "Geo",
        icon: "MapIcon",
        requireRoles: [
          'GeoReaders',
          'GeoWriters',
          'Admin'
        ],
        submenu: [
          {
            url: "/geo/scenarios",
            i18n: 'GeoScenarioPage.Title',
            name: "Scenarios",
            slug: "geo-scenarios",
            icon: "MapIcon",
            requireRoles: [
              'GeoWriters',
              'Admin'
            ]
          },
          {
            url: "/geo/nsr",
            i18n: 'Geo.NSR.Title',
            name: "NSR Analytics",
            slug: "external",
            icon: "Trending-UpIcon",
            requireRoles: [
              'GeoReaders',
              'Admin'
            ]
          },
          {
            url: "/geo/geostats",
            name: "Model QA/QC",
            i18n: 'Geo.QAQC.Title',
            slug: "goe-stats",
            icon: "Trending-UpIcon",
            requireRoles: [
              'GeoReaders',
              'Admin'
            ]
          },
          {
            url: "/mrmr/periods",
            name: "Statement Periods",
            i18n: 'MRMR.Period.Title',
            slug: "mrmr-periods",
            icon: "ClockIcon",
            requireRoles: [
              'MRMRConsolidation',
              'Admin'
            ]
          },
          {
            url: "/mrmr/statements",
            name: "Statements",
            i18n: 'MRMR.Statement.Title',
            slug: "mrmr-statements",
            icon: "Trending-UpIcon",
            requireRoles: [
              'MRMRCollaborators',
              'MRMRConsolidation',
              'Admin'
            ]
          }
        ]
      },
      {
        url: "/geo/gradecontrol",
        name: "Grade Control",
        i18n: 'GradeControl.Title',
        slug: "gradecontrol",
        icon: "ClockIcon",
        requireRoles: [
          'GradeControlReaders',
          'Admin'
        ],
        submenu: [
          {
            url: "/geo/gradecontrol/timesheet",
            name: "Timesheet",
            i18n: 'GradeControl.Timesheet.Title',
            slug: "gradecontrol-timesheet",
            icon: "LayersIcon",
            requireRoles: [
              'GradeControlCollaborators',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/samples",
            name: "Sample",
            i18n: 'GradeControl.Sample.LIMSTitle',
            slug: "gradecontrol-sample",
            icon: "LayersIcon",
            requireRoles: [
              'SamplesWriters',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/forecast",
            name: "Forecast",
            i18n: 'GradeControl.Forecast.Title',
            slug: "gradecontrol-forecast",
            icon: "EyeIcon",
            requireRoles: [
              'GradeControlCollaborators',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/productionSummary",
            name: "Production Summary",
            i18n: 'GradeControl.ProductionSummary.Title',
            slug: "gradecontrol-forecast",
            icon: "TruckIcon",
            requireRoles: [
              'GradeControlReaders',
              'GradeControlCollaborators',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/monthlySummary",
            name: "Monthly Summary",
            i18n: 'GradeControl.MonthlySummary.Title',
            slug: "gradecontrol-forecast",
            icon: "EyeIcon",
            requireRoles: [
              'GradeControlReaders',
              'GradeControlCollaborators',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/posting",
            name: "Posting",
            i18n: 'GradeControl.Posting.Title',
            slug: "gradecontrol-posting",
            icon: "EyeIcon",
            requireRoles: [
              'GradeControlCollaborators',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/reports",
            name: "Reports",
            i18n: 'GradeControl.Reports.Title',
            slug: "gradecontrol-reports-index",
            icon: "Trending-UpIcon",
            requireRoles: [
              'GradeControlReaders',
              'Admin'
            ]
          },
          {
            url: "/geo/gradecontrol/admin",
            name: "Admin",
            i18n: 'GradeControl.Admin.Title',
            slug: "gradecontrol-admin-index",
            icon: "LockIcon",
            requireRoles: [
              'GradeControlCollaborators',
              'Admin'
            ]
          }
        ]
      },
      drillPages.getNavMenu()
    ]
  }
]
